import axios from 'axios'

const DEV_TOKEN = 'e0f475c0fbe821451af88df17cb5027db7a80dd9d44936d674b9cb18b5db92f1523f7a221f2fcad43371ae36b3f42e0f9849a1ac0f49ac6316c14924687e5ae674ce83ccff90f6c0793d73038274b6c8280cf43a4c4a830a6f6f3dd37f914bcd77f2dd95b7a6182c67886aa3e8b2f1abc3955baeb2659f403429bd65c60c2dbe'
const PROD_TOKEN = 'a07b386c8cea698677e515541e1e0b5d627fd98932aab73fa6b43b1a74bc766080148b9d4c23fb19fbb63c542d2a1fd146e652bbf1fffdf75dcfaf1f13df17d934e32cf3fdc72b7f8b68776bde544cb9bae1f15df0fce49bed3478243820482df6b5b2de7e2ec53a8bbacd24029c8ab5442ded2f13af024944c299107b883c14'

export const API_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:1337' : 'https://generous-paradise-2045a21aad.strapiapp.com'

const api = axios.create({
  baseURL: `${API_URL}/api/`,
  headers:
    {
      Authorization: `Bearer ${process.env.NODE_ENV === 'development' ? DEV_TOKEN : PROD_TOKEN}`
    }
})

export default api
